// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/Users/yingben001/IdeaProjects/edatlink-box-admin/node_modules/.pnpm/@ant-design+icons@4.8.0_biqbaboplfbrettd7655fr4n2y/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import TableOutlined from '/Users/yingben001/IdeaProjects/edatlink-box-admin/node_modules/.pnpm/@ant-design+icons@4.8.0_biqbaboplfbrettd7655fr4n2y/node_modules/@ant-design/icons/es/icons/TableOutlined';
export default { SmileOutlined, TableOutlined };
